module.exports = __webpack_public_path__ + "static/magazine-1-83bebf85bd23411515c6544de35abb54.jpg";